import { useMetricsStats, useMetricsDistribution } from '../../../../../shared/hooks';
import type { MetricsFilters, MetricsStatsParams } from '../../../../../shared/api/types';

export const useProgrammeProfileStats = (params?: MetricsStatsParams) => {
  return useMetricsStats({
    ...params,
    metrics: params?.metrics || ['total_users', 'active_users', 'participation_rate', 'completion_rate'],
  });
};

export const useAgeDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: 'age_distribution',
  });
};

export const useWorkingEnvironment = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: 'working_environment',
  });
};

export const useDemographics = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: 'demographics',
  });
};

export const useTravelTime = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: 'travel_time',
  });
};

export const useProgrammeGoals = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: 'programme_goals',
  });
};

export const useWorkingHourPatterns = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: 'working_hour_patterns',
  });
};

export const useLifestyleHabits = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: 'lifestyle_habits',
  });
};

export const useActiveUsersByDepartment = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: 'active_users_by_department',
  });
};
